import { useAtomValue } from "jotai";
import pym from "pym.js";
import { useEffect, useState } from "react";

import { config } from "shared/data";
import { accountAtom } from "shared/lib/account";

import { pathname as newsletterPathname } from "./index";

declare global {
  interface Window {
    pymChild?: pym.Child;
  }
}

export function getPymChild(): pym.Child {
  window.pymChild ??= new pym.Child();
  return window.pymChild;
}

export const useNewsletterUrl = () => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  const [newsletterUrl, setNewsletterUrl] = useState(newsletterPathname);

  useEffect(() => {
    if (isLoggedIn === true) {
      setNewsletterUrl(`${config.account.scmpAccountHost}/manage/newsletter`);
    }
  }, [isLoggedIn]);

  return {
    newsletterUrl,
  };
};
